import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; 
import App from './App';

// Load Mapbox CSS from CDN (non-blocking)
const mapboxCSS = document.createElement('link');
mapboxCSS.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
mapboxCSS.rel = 'stylesheet';
mapboxCSS.onload = () => console.log('Mapbox CSS loaded');
document.head.appendChild(mapboxCSS);

// Load Mapbox JS from CDN (non-blocking, async)
const mapboxJS = document.createElement('script');
mapboxJS.src = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js';
mapboxJS.async = true;
mapboxJS.defer = true;
mapboxJS.onload = () => {
  console.log('Mapbox GL JS loaded');
};
document.head.appendChild(mapboxJS);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// Dispatch app-ready event after React mounts
setTimeout(() => {
  window.dispatchEvent(new Event('app-ready'));
  window.appHasLoaded = true;
}, 500);
